import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type TRefreshProps = {
  title: boolean;
};

const initialState = {
  showRefresh: false,
  title: false,
};

export const refreshSlice = createSlice({
  name: 'refreshSlice',
  initialState,
  reducers: {
    showRefresh: (
      state,
      action: PayloadAction<TRefreshProps>
    ) => {
      if (state.showRefresh) {
        return state;
      } else {
        const payload = action.payload;
        return {
          showRefresh: true,
          ...payload,
        };
      }
    },
    removeRefresh: () => initialState,
  },
});

export const { showRefresh, removeRefresh } =
  refreshSlice.actions;

export default refreshSlice.reducer;
